import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ACTIONS, URLS } from '../../_config';
import { useStoreApi } from '../../store/api/hooks/storeApiHook';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import Icon from '../../components/icons';
import { toast } from 'react-hot-toast';
import { useStoreSelector } from '../../store/selectors/userSelector';
import './style.css';
import Spinner from '../../components/iconSvgs/spinner';
import { StoreTpypeApiResponse } from '../../_config/interfaces/interfaces';

const StoreCreate: React.FC = () => {
    const [isOnSubmitLoading, setOnSubmitLoading] = useState<boolean>(false);
    const [storeTypeList, setStoreTypeList] = useState<Array<StoreTpypeApiResponse>>([]);
    const { register, formState: { errors }, handleSubmit, } = useForm<any>();

    const store = useStoreSelector();
    const storeAPI: any = useStoreApi();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const getStores = () => {
        storeAPI.getStore({}, (msg: any, resp: any) => {
            // console.log('response =>', resp, msg);
            if (resp?.data) {
                dispatch({
                    type: ACTIONS.STORE.GET_STORE,
                    payload: resp.data,
                });
                navigate(URLS.STORE.BRANCHES);
            } else {
                navigate(URLS.STORE.CREATE);
            }
        }, (err: any) => {
            // console.log('error =>', err);
            // toast.error(err);
            navigate(URLS.STORE.CREATE);
        })
    }

    const getStoreTypes = () => {
        storeAPI.getStoreTypes({}, (msg: any, resp: any) => {
            // console.log('response =>', resp, msg);
            setStoreTypeList(resp?.data);
        }, (err: any) => {
            // console.log('error =>', err);
            // toast.error(err);
            navigate(URLS.STORE.CREATE);
        })
    }

    const onSubmit = (data: any) => {
        setOnSubmitLoading(true);
        const param = {
            name: data.storeName,
            storetype_id: data.storeType,
            branches: [
                {
                    branch_name: "Branch 1",
                    address: data.storeAddress,
                    contact_info: "+9999999999"
                }
            ]
        }
        // console.log({param, data});
        // setOnSubmitLoading(false);
        // return;

        try {
            setTimeout(() => {
                storeAPI.addStore(param, (msg: any, resp: any) => {
                    // console.log('response =>', resp);
                    if (resp?.code === 201) {
                        dispatch({
                            type: ACTIONS.STORE.GET_STORE,
                            payload: resp.data,
                        });
                        navigate(URLS.STORE.BRANCHES);
                    } else {
                        toast.error(resp?.message);
                    }
                }, (error: any, resp: any) => {
                    // console.log('error =>', error, resp);
                    if (resp?.detail?.code === 400) {
                        toast.error(resp?.detail?.message);
                        if (!resp?.detail?.data) {
                            getStores();
                        }
                        // navigate(URLS.STORE.BRANCHES);
                    } else {
                        toast.error("Something went wrong");
                    }
                });

                setOnSubmitLoading(false);
            }, 5000)
        } catch (e) {
            // console.log('error =>', e);
            setOnSubmitLoading(false);
        }
    };

    useEffect(() => {
        getStoreTypes()
    },[])

    return (
        <div className="flex min-h-screen">
            {isOnSubmitLoading && (
                <div className="absolute inset-0 bg-gray-700 bg-opacity-50 flex justify-center items-center z-50">
                    <Spinner className="self-center z-50" />
                </div>
            )}
            
            <div className="flex flex-col justify-center items-center w-full lg:w-4/12 sm:w-4/12 px-6 py-12 lg:px-8 bg-white">
                <div className="sm:mx-auto sm:w-full sm:max-w-2xl">
                    <img className="h-15 w-auto mb-[92px]" src="/assets/images/Frame_2.png" alt="hubwallet logo" />
                    <h2 className="mt-10 text-left text-2xl font-bold tracking-tight text-gray-900">Add Store</h2>
                    <p className="mt-1 text-left text-base tracking-tight text-gray-500">Add store name and store type</p>
                </div>

                <div className="mt-5 sm:mx-auto sm:w-full sm:max-w-2xl">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="mb-5">
                            <div className="mt-2 relative">
                                <input
                                    type="text"
                                    {...register("storeName", { required: true })}
                                    placeholder="Store Name"
                                    autoComplete="username"
                                    className={`block-lg w-full rounded-sm bg-white px-3 py-1.5 pr-10 text-sm text-gray-900 outline outline-1 -outline-offset-1 ${errors.storeName ? 'outline-red-500 outline-2' : 'outline-gray-300'} placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm`}
                                />
                                <Icon name="store" size={20} className="absolute right-3 top-[25px] transform -translate-y-1/2 text-gray-400" />
                            </div>
                        </div>

                        <div className="mb-5">
                            <div className="mt-2 relative">
                                <select {...register("storeType", { required: true })}
                                    className={`block-lg w-full rounded-sm bg-white px-3 py-1.5 pr-10 text-sm text-gray-900 outline outline-1 -outline-offset-1 ${errors.storeType ? 'outline-red-500 outline-2' : 'outline-gray-300'} focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm focus`}
                                    id="addBranch" defaultValue=""
                                    style={{
                                        appearance: 'none', // Hides default dropdown icon
                                        WebkitAppearance: 'none', // For Safari and other webkit-based browsers
                                        MozAppearance: 'none', // For Firefox
                                        backgroundImage: 'none', // Removes default dropdown icon
                                    }}

                                >
                                    <option value="" disabled className='text-gray-400'>
                                        Select Store Type
                                    </option>
                                    {
                                        storeTypeList?.map((item: StoreTpypeApiResponse) => (
                                            <option key={item.storetype_id} value={item.storetype_id} className="text-gray-500">
                                                {item.store_type}
                                            </option>
                                        ))
                                    }
                                </select>
                                <Icon name="arrow-down" size={20} className="absolute right-3 top-[25px] transform -translate-y-1/2 text-gray-400" />

                            </div>
                        </div>


                        <div className="mb-5">
                            <div className="mt-2 relative">
                                <textarea rows={8}  // Increased the rows here
                                    {...register("storeAddress", { required: true, minLength: { value: 5, message: "Store address must be at least 5 characters long." } })}

                                    placeholder="Store Address"
                                    className={`block-lg w-full rounded-sm bg-white px-3 py-1.5 pr-10 text-sm text-gray-900 outline outline-1 -outline-offset-1 ${errors.storeAddress ? 'outline-red-500 outline-2' : 'outline-gray-300'} focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm`}
                                />
                                <Icon name="location" size={20} className="absolute right-3 top-[25px] transform -translate-y-1/2 text-gray-400" />
                            </div>
                            {errors.storeAddress && (
                                <span className="text-red-500 text-xs">Store address must be at least 5 characters long.</span>
                            )}
                        </div>


                        <div className="mb-5">
                            <button
                                type="submit"
                                className="flex w-full justify-center rounded-sm bg-blue-500 p-4 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                            >
                                Submit
                            </button>
                        </div>
                    </form>


                </div>
            </div>

            {/* Right Side: Background Image Section */}
            <div className="hidden sm:block lg:w-8/12 sm:w-8/12 bg-cover" style={{ backgroundImage: 'url(/assets/images/2148204009-1.jpg)' }}>
            </div>
        </div>
    );
};

export default StoreCreate;